import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { optimizeListingData, optimizeVehicleFeatures } from '@/utilities/vehicleSummaryUtils';

import { vdpDuckPreset } from '@/ducks/presets/index.js';

import VehicleSummaryFetcher from '@/fetchers/vdp/VehicleSummaryFetcher';

import vdpModelInfoDuck from './vdpModelInfoDuck';
import vdpResultsDuck from './vdpResultsDuck';

const vdpVehicleSummaryDuck = objectDuckCreator({
    ...vdpDuckPreset,
    store: 'vehicleSummary',
    initialState: {
        data: {},
        isLoading: false,
    },
}).extend({
    selectors: () => ({
        isLoading: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).isLoading),
        data: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).data),
    }),
    creators: () => ({
        loadVehicleSummary: () => async (dispatch, getState) => {
            const listing = vdpResultsDuck.selectors.getVdpActiveInventory(getState());
            const optimizedListing = optimizeListingData(listing);
            const { features } = vdpModelInfoDuck.selectors.getModelInfo(getState()) || {};
            const optimizedFeatures = optimizeVehicleFeatures(features);
            const vehicleDetails = {
                listing: optimizedListing,
                additionalFeatures: optimizedFeatures,
            };

            await dispatch(vdpVehicleSummaryDuck?.creators.setKeys({ isLoading: true }));
            try {
                const response = await VehicleSummaryFetcher({ vehicleDetails });
                await dispatch(vdpVehicleSummaryDuck?.creators?.setKeys({
                    data: {
                        summary: response?.response || '',
                        listingId: listing?.id,
                        sessionId: response?.sessionId,
                    },
                    isLoading: false,
                }));
            } catch (error) {
                await dispatch(vdpVehicleSummaryDuck?.creators?.setKeys({
                    data: {
                        error,
                        listingId: listing?.id,
                    },
                    isLoading: false,
                }));
            }
        },
    }),
});

export default vdpVehicleSummaryDuck;
